const apiVersions = {};

export default apiVersions;
